export default __webpack_public_path__ + "static/media/new-icon-subscription.048ef644.svg";